import { Access } from '@/types';

// List of capability names that should be displayed as 'chariot'
const CAPABILITY_NAMES = [
  'nuclei',
  'portscan',
  'crawler',
  'qualys',
  'portswigger',
  'ssh',
  'resolver',
  'reverse-csp',
  'integration-affiliation',
  'microsoft-defender',
  'affiliation',
  'cisa-ch-webappscan-import',
  'cisa-rva-import',
  'tenable',
  'rapid7',
  'github-repository',
  'azuread-discovery',
  'secrets',
  'cidr',
  'ipv4',
  'ipv6',
  'certificate',
  'whois',
  'service',
  'plextrac',
];

export const getAccessEmail = (accesss: Access[], key?: string) => {
  if (!key) return key;

  // Handle access keys
  if (key.startsWith('#access')) {
    return accesss.find(a => a.key === key)?.email || key;
  }

  // Handle capability names - return 'Praetorian' for known capabilities
  if (CAPABILITY_NAMES.includes(key)) {
    return 'Praetorian';
  }

  // Return original key for user emails and unknown values
  return key;
};
